import { baseApi } from '@/shared/api'
import { mapSession } from '../lib/mapSession'
import { User, type Session } from '../model/types'

export const sessionApi = baseApi.injectEndpoints({
  endpoints: build => ({
    login: build.mutation<Session, { email: Email }>({
      query: body => ({
        url: `/login`,
        method: 'POST',
        body,
      }),
    }),
    logout: build.mutation<Session, void>({
      query: () => ({
        url: `/logout`,
        method: 'POST',
      }),
    }),

    sendOtp: build.mutation<Session, { otp: string }>({
      query: body => ({
        url: `/login/otp`,
        method: 'POST',
        body,
      }),
      transformResponse: mapSession,
    }),
    me: build.mutation<User, void>({
      query: () => ({
        url: `/user`,
      }),
    }),
  }),
})

export const {
  useLoginMutation,
  useSendOtpMutation,
  useLogoutMutation,
  useMeMutation,
} = sessionApi
